module.exports = __webpack_public_path__ + "assets/img/68b0c4fcb84d239f261c1a5e65818142.gif";